var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24.808,
  height: 32.916,
  viewBox: "0 0 24.808 32.916"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M689.536,1639.8l.485-.341,2.4,1.388,2.4,1.388-.053.591a7.914,7.914,0,0,1-7.671,7.227h0a7.918,7.918,0,0,1,2.432-10.253Z",
  transform: "translate(-682.694 -1617.14)",
  fill: "#fac15b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.391,1623.739c4.949,2.858,7.213,8.2,4.5,12.885l-1.288,2.23c-2.708,4.689-2.528-4.875-7.476-7.733s-13.162,2.1-10.436-2.616l1.285-2.225c2.708-4.689,8.462-5.4,13.411-2.541Z",
  transform: "translate(-680.155 -1609.767)",
  fill: "#ff2f2f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M691.99,1621.534a18.852,18.852,0,0,1,14.626-20.331l1.9-.453.558,1.874a18.852,18.852,0,0,1-10.3,22.828Z",
  transform: "translate(-685.125 -1600.75)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M706.991,1603.714a21.963,21.963,0,0,1,7.918-2.964,21.715,21.715,0,0,1,1.389,8.339C714.2,1605.442,710.814,1604.17,706.991,1603.714Z",
  transform: "translate(-691.516 -1600.75)",
  fill: "#ff2f2f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M691.239,1640.413l.377-.264,1.858,1.073,1.853,1.071-.041.458a6.114,6.114,0,0,1-5.922,5.58h0A6.114,6.114,0,0,1,691.239,1640.413Z",
  transform: "translate(-683.742 -1617.431)",
  fill: "#ff772f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M692.615,1640.644l.29-.2,1.415.817,1.415.818-.031.353a4.672,4.672,0,0,1-4.523,4.262h0A4.672,4.672,0,0,1,692.615,1640.644Z",
  transform: "translate(-684.586 -1617.555)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M697.191,1636.236l-4.918-2.841a18.111,18.111,0,0,1,.293-8.7c-.134,6.41.614,11.344,6.8,10.605A17.658,17.658,0,0,1,697.191,1636.236Z",
  transform: "translate(-685.115 -1610.89)",
  fill: "#ddd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M699.434,1628.4c.8.461.191,3.043-2.075,6.96s-3.912,5.257-4.719,4.767c-.8-.465-.5-2.557,1.766-6.473C696.7,1629.729,698.6,1627.919,699.434,1628.4Z",
  transform: "translate(-685.27 -1612.425)",
  fill: "#ff2f2f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M707.048,1605.881c3.607.5,7.023,1.507,9.274,5.38a18.75,18.75,0,0,1-1.234,5.921C716.535,1609.47,711.7,1607.761,707.048,1605.881Z",
  transform: "translate(-691.541 -1602.922)",
  fill: "#ddd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M707.664,1613.687a2.736,2.736,0,1,0,1.935-3.35A2.738,2.738,0,0,0,707.664,1613.687Z",
  transform: "translate(-691.762 -1604.769)",
  fill: "#ffca1f",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M704.762,1622.731a1.584,1.584,0,1,0,1.12-1.94,1.587,1.587,0,0,0-1.12,1.94Z",
  transform: "translate(-690.55 -1609.212)",
  fill: "#ffca1f",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 0.7
}))));
export default __webpack_public_path__ + "static/media/rocket-red.5cc02550.svg";
export { SvgComponent as ReactComponent };